import EntityService from '@/services/EntityService'
import { Material } from '@/models/material'

export default class MaterialService extends EntityService<Material> {
  constructor() {
    super({ collectionName: 'materials' })
  }
}